<template>
    <div>
        <header class="text-left search_equipment d-flex user-detail row">
            <div class="col-md-8 d-flex justify-content-between mx-3 mx-md-auto align-items-center">
                <b-img :src="require('@/assets/small-logo.png')" width="35" height="40"></b-img>
                <div class="d-flex align-items-center gap-3">
                    <!-- <div class="position-relative mr-3">
                        <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M22.1609 15.7696L19.8273 13.436V10.3447C19.8246 8.20836 19.0299 6.14891 17.5968 4.56457C16.1638 2.98023 14.1941 1.98353 12.0688 1.76721V0H10.3447V1.76721C8.21934 1.98353 6.2497 2.98023 4.81663 4.56457C3.38355 6.14891 2.58884 8.20836 2.58617 10.3447V13.436L0.252582 15.7696C0.0909043 15.9312 4.88246e-05 16.1505 0 16.3791V18.9652C0 19.1939 0.0908235 19.4131 0.25249 19.5748C0.414157 19.7365 0.633425 19.8273 0.862056 19.8273H6.89645V20.4971C6.8777 21.5907 7.26317 22.6528 7.979 23.4799C8.69484 24.3069 9.69068 24.8407 10.7757 24.9789C11.375 25.0384 11.9801 24.9717 12.552 24.7832C13.124 24.5948 13.6502 24.2887 14.0968 23.8847C14.5434 23.4806 14.9004 22.9876 15.145 22.4373C15.3896 21.887 15.5163 21.2916 15.517 20.6893V19.8273H21.5514C21.78 19.8273 21.9993 19.7365 22.161 19.5748C22.3226 19.4131 22.4135 19.1939 22.4135 18.9652V16.3791C22.4134 16.1505 22.3226 15.9312 22.1609 15.7696ZM13.7929 20.6893C13.7929 21.3752 13.5204 22.033 13.0354 22.518C12.5504 23.003 11.8926 23.2755 11.2067 23.2755C10.5208 23.2755 9.86303 23.003 9.37803 22.518C8.89303 22.033 8.62056 21.3752 8.62056 20.6893V19.8273H13.7929V20.6893ZM20.6893 18.1032H1.72411V16.736L4.0577 14.4024C4.21938 14.2407 4.31023 14.0215 4.31028 13.7929V10.3447C4.31028 8.51562 5.03687 6.76148 6.3302 5.46815C7.62354 4.17481 9.37768 3.44822 11.2067 3.44822C13.0358 3.44822 14.7899 4.17481 16.0833 5.46815C17.3766 6.76148 18.1032 8.51562 18.1032 10.3447V13.7929C18.1032 14.0215 18.1941 14.2407 18.3558 14.4024L20.6893 16.736V18.1032Z"
                                fill="white" />
                        </svg>
                        <div class="notifications-count" v-if="userNotifications && userNotifications.filter((notification)=>!notification.is_read).length">
                            {{ userNotifications.filter((notification)=>!notification.is_read).length }}
                        </div>
                    </div> -->
                    <LanguageFlagDropdown class="mr-3"/>
                    <NotificationHeader />
                    <b-dropdown id="dropdown-right" right
                        class="mx-2 dropdown dropdown-dark-section header-section-dropdown">
                        <template slot="button-content" v-if="user">
                            <b-img v-if="user && user.team_member && user.team_member.profile_picture"
                                class="userSmallImage rounded-circle" :src="user.team_member.profile_picture"></b-img>
                            <div v-else class="user-default-img">
                                {{ user.first_name.charAt(0).toUpperCase() }}{{ user.last_name.charAt(0).toUpperCase() }}
                            </div>
                        </template>
                        <b-dropdown-item><div class="d-flex flex-column"><span class="font-weight-bold f-14">{{ user.first_name }} {{ user.last_name }}</span>
         <span class="f-12">{{ user.email }}</span>
         </div>
        </b-dropdown-item>
                        <hr class="my-2" />
                        <!-- <b-dropdown-item to="/profile-page" v-if="userCompany"><span class="f-14">{{ $t('header.viewProfile') }}</span></b-dropdown-item> -->
                        <b-dropdown-item to="/all-companies"><span class="f-14">{{ $t('header.viewCompanies') }}</span></b-dropdown-item>
                        <hr class="my-2" />
                        <b-dropdown-item @click="OnlogoutUser"><span class="f-14">{{ $t('header.logout') }}</span></b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </header>
        <b-form @submit.prevent="setCreateCompanyModalVisible">
            <div class="col-lg-6 col-md-8 mx-3 mx-md-auto pt-64">
                <h1 class="font-weight-bold f-32 text-left mt-3 mb-3">{{ $t('createCompanyPage.title') }} </h1>
                <b-row>
                    <b-col sm="12">
                        <b-form-group :label="$t('createCompanyPage.companyNameLabel')" class="text-left label">
                            <b-form-input type="text" :placeholder="$t('createCompanyPage.companyNamePlaceholder')" class="input" required
                                v-model="company.company_name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12 mb-3">
                        <v-app>
                            <v-tooltip bottom>
                                <template #activator="{ on, attrs }">
                                    <label class="text-left w-fit-content" v-on="on" v-bind="attrs">{{ $t('createCompanyPage.compIdLabel') }}</label>
                                </template> {{ $t('createCompanyPage.compIdTooltip') }}
                            </v-tooltip>
                        </v-app>
                        <b-form-input type="text" :placeholder="$t('createCompanyPage.compIdPlaceholder')" class="input" required
                            v-model="company.company_id"></b-form-input>
                        <p v-if="errors && errors.company_id" class="field-error text-left mb-4">
                            {{ errors.company_id[0] }}
                        </p>
                        <b-form-group :label="$t('createCompanyPage.numDriversLabel')" class="text-left label mt-3">
                            <b-form-input type="number" :placeholder="$t('createCompanyPage.numDriversPlaceholder')" class="input" required
                                v-model="company.expected_no_of_drivers"></b-form-input>
                        </b-form-group>
                        <div class="d-flex justify-content-end flex-wrap gap-3 mt-4">
                            <b-button class="mx-0 f-14 d-flex align-items-center justify-content-center h-40px w-100px"
                                to="/all-companies" variant="secondary">{{ $t('createCompanyPage.cancel') }}</b-button>
                            <b-button type="submit" class="w-100px login h-40px" variant="primary">{{ $t('createCompanyPage.confirm') }}</b-button>
                        </div>

                    </b-col>
                </b-row>
            </div>
        </b-form>
        <DeleteModal :message="$t('createCompanyPage.confirmCreate')" :updateMessage="true" :removeMessage="''"
            v-if="createCompanyModalVisible" @confirm="createCompany" />
    </div>
</template> 
<script>
import { mapGetters, mapActions } from "vuex";
import DeleteModal from "@/components/DeleteModal.vue";
import NotificationHeader from "@/components/Shared/NotificationHeader.vue";
import { clearGleapUser, initGleapWithUser } from "@/plugins/gleap";
import LanguageFlagDropdown from "@/components/Shared/LanguageFlagDropdown.vue";

export default {
    name: "create-company",
    components: { NotificationHeader, DeleteModal, LanguageFlagDropdown },
    data() {
        return {
            createCompanyModalVisible: false,
            company: {
                company_name: "",
                company_id: "",
                company_type: 2,
                expected_no_of_drivers: null,
            },
            errors: null,
        }
    },
    computed: {
        ...mapGetters(['user', 'userCompany', 'userNotifications']),
        canAddCompany() {
            return this.$store.state.user?.user?.team_member?.can_add_company || this.$store.state.user?.user?.can_add_company
        }
    },
    watch: {
        canAddCompany: {
            handler(newVal) {
                // Redirect if user data is loaded and user doesn't have permission
                if (this.$store.state.user?.user?.team_member && !newVal) {
                    this.$router.push({ name: 'AllCompanies' });
                }
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions(["logoutUser", "getUserByID", "setNotification", "setLoader", "createCompanyOnly", "createUserLogs"]),
        async createUserCompany() {
            try {
                this.setLoader(true)
                await this.createCompanyOnly({
                    data: {
                        ...this.company,
                        source: "", expected_no_of_drivers: this.company.expected_no_of_drivers
                    }
                })
                await this.setNotification({
                    msg: this.$t('createCompanyPage.created'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
                // this.step++
                this.$router.push("/all-companies");

            }
            catch (error) {
                this.setLoader(false)
                if (Array.isArray(error.error)) {
                    this.setNotification({
                        msg: error.error[0],
                        type: "error",
                        color: "red",
                    });
                }
                else if (error.status || error.name)
                    this.setNotification({
                        msg: this.$t('createCompanyPage.duplicate'),
                        type: "error",
                        color: "red",
                    });
            }
        },
        setCreateCompanyModalVisible() {
            this.createCompanyModalVisible = true;
        },

        async createCompany(status) {
            if (status) {
                try {
                    const regex = /^[A-Za-z0-9_-]{3,}$/;
                    const isCompanyIDValid = regex.test(this.company.company_id);
                    if (isCompanyIDValid) {
                        await this.createUserCompany()
                        this.errors = {}
                        this.createCompanyModalVisible = false;
                    }
                    else {
                        let error = {};
                        error['company_id'] = [this.$t('createCompanyPage.compIdInvalid')];
                        throw error;
                    }
                }
                catch (error) {
                    this.createCompanyModalVisible = false;
                    if (typeof error === "object") {
                        this.errors = error;
                    }
                }
            }
            else {
                this.createCompanyModalVisible = false;
            }
        },
        async OnlogoutUser() {
            if (localStorage.getItem('userSelectedCompany')) {
                await this.createUserLogs({ action: 'logout' });
            }
            this.logoutUser();
            if (!process.env.VUE_APP_SHOW_INTERCOM) {
                clearGleapUser();
            }
            this.$router.push("/login");
        },
    },
    async mounted() {
        await this.getUserByID();

        if (!process.env.VUE_APP_SHOW_INTERCOM && this.user) {
            initGleapWithUser(this.user, null);
        }
    }
}
</script>